<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title">Run Links Analysis</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li>
          <a routerLink="/global-admin-panel" routerLinkActive="active">Global Admin Panel</a>
        </li>
        <li class="separator">></li>
        <li class="active">Run Links Analysis</li>
      </ul>
    </div>
  </div>
  <div class="mat-card-wrapper">
    <mat-card-content class="mcd-card-content">
      <div class="role-cards-grid">
        
        <!-- Run Script Card -->
        <div class="role-card" (click)="runscript(dynamicEmail)">
          <div class="card-icon-wrapper orange-theme">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="3" width="16" height="18" rx="2" stroke="#d97706" stroke-width="2"/>
              <path d="M8 8H16" stroke="#d97706" stroke-width="2" stroke-linecap="round"/>
              <path d="M8 12H14" stroke="#d97706" stroke-width="2" stroke-linecap="round"/>
              <path d="M8 16H11" stroke="#d97706" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          
          <h3 class="role-title">Run Script for Link Analysis</h3>
          <p class="role-description">Execute automated scripts to map and analyze link relationships across datasets.</p>

          <div class="card-action-footer">
            <button 
              type="button" 
              class="role-action-btn" 
              [disabled]="run_script" 
              (click)="$event.stopPropagation(); runscript(dynamicEmail)"
            >
              Run
            </button>
          </div>
        </div>

        <!-- Link Analysis Report Card -->
        <div class="role-card" (click)="openHtmlFile()">
          <div class="card-icon-wrapper green-theme">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="#10b981" stroke-width="2"/>
              <path d="M12 7V12L15 15" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          
          <h3 class="role-title">Link Analysis Report</h3>
          <p class="role-description">View detailed reports on link structures, patterns, and connection insights.</p>

          <div class="card-action-footer">
            <button 
              type="button" 
              class="role-action-btn" 
              [disabled]="view_script" 
              (click)="$event.stopPropagation(); openHtmlFile()"
            >
              View
            </button>
          </div>
        </div>

      </div>
    </mat-card-content>
    <mat-card-footer class="mcd-card-footer"> </mat-card-footer>
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
